import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { StagingBanner } from "./components/StagingBanner";
import "./styles.css";

const qc = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, refetchOnWindowFocus: false },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <HashRouter>
        <App />
        {/* Fixed-position banner rendered as a sibling of App so it
          * survives every early-return branch inside App
          * (BrandedLoading, Privacy, invite mode, Login, etc.) —
          * only visible on the preview build for the platform
          * developer; a no-op in production. */}
        <StagingBanner />
      </HashRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

// First-launch viewport fix for iOS WKWebView. On the very first
// cold-start after install, WKWebView occasionally paints the page
// before it has the correct visualViewport dimensions — every CSS
// rule that reads vw/vh/env(safe-area-inset-*) gets stale values
// and the layout renders too big until the next launch. Dispatching
// a resize event on the next two animation frames forces every
// layout-dependent piece (Tailwind utilities, our env() padding,
// component measureLayout calls) to recompute with the now-settled
// viewport. Cheap and idempotent — on subsequent launches the
// viewport is already correct so the extra resize is a no-op.
if (typeof window !== "undefined") {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.dispatchEvent(new Event("resize"));
    });
  });
}
